/**
 * Created by bailey on 15/3/13.
 * android native 模拟方法
 */
var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase();


//native类的接口，全部需要容错，以防止在老版本的app中调用触发错误，或者在对外公开页面中访问时出现错误。

//先判断native对象是否存在，如果不存在（处于纯粹浏览器环境），则创建该对象
if(!window.native){
    window.native = {};
}

//每个接口方法，都需要判断其是否存在，如果不存在则至少提供一个空方法以避免报错
//空方法数组
var methods = ["goBack","initTopbar","scanBarCode","setAlignment","printBitmap","lineWrap","println","browseImage","closeCurrentPage","takePictures","textToSpeech"];

/*for (var i = 0; i < methods.length; i++) {
    var m = methods[i];
    if(!!!native[m]){
        native[m] = function(){}
    }
}*/

//浏览器端有伪造实现的方法

if(!!!native.goBack){
    native.goBack = function(info){
       // history.go(-1);
    }
}

if(!!!native.initTopbar){
    native.initTopbar = function(str){
        console.log("进入－－"+str);
    }
}

if(!!!native.scanBarCode) {
    native.scanBarCode = function(str) {
        console.log('调用扫码,回调为'+str);
    }
}

if(!!!native.setAlignment){
    native.setAlignment = function(code,fuc){
        // console.log('设置对齐方式,对齐方式'+code+',回调为'+fuc);
        console.log('设置对齐方式,对齐方式'+code);
    }
}

if(!!!native.printBitmap){
    native.printBitmap = function(base64,fuc){
        // console.log('打印图片,回调为'+fuc);
        console.log('打印图片');
    }
}

if(!!!native.lineWrap){
    native.lineWrap = function(code,fuc){
        // console.log('换行'+code+',回调为'+fuc);
        console.log('换行'+code);
    }
}

if(!!!native.println){
    native.println = function(str,fuc){
        // console.log('打印文字为\n'+str+',回调函数为'+fuc);
        console.log('打印文字为\n'+str);
    }
}

if(!!!native.browseImage){
    native.browseImage = function(str){
        console.log('添加本地图片'+str);
    }
}

if(!!!native.closeCurrentPage){
    native.closeCurrentPage = function(){
        console.log('关闭当前页面');
    }
}

if(!!!native.takePictures){
    native.takePictures = function(str){
        console.log('调出摄像头'+str);
    }
}

if(!!!native.scanNfcCard) {
    native.scanNfcCard = function(time,str) {
        console.log('开始扫卡' + str);
    }
}

if(!!!native.exitPage){
    native.exitPage = function(str){
        console.log("离开－－"+str);
    }
}


if(!!!native.keepWaking) {
    native.keepWaking = function (ifKeepWaking) {
        console.log(ifKeepWaking ? "该页面需要保持常亮":"该页面不需要保持常亮");
    };
}

if(!!!native.textToSpeech) {
    native.textToSpeech = function(str,fuc) {
        console.log('播报文字为'+str+',回调函数为'+fuc);
    }
}

// native.getDataByBluetooth
if(!!!native.getDataByBluetooth) {
    native.getDataByBluetooth = function(num) {
        console.log('请求获取蓝牙条数为'+num);
    }
}

// native.getPdaInfo
if(!!!native.getPdaInfo) {
    native.getPdaInfo = function(func) {
        console.log('获取PDA版本号' + '回调函数为' + func);
    }
}


